import { useEffect, useState } from "react";

const STORAGE_KEY = "ss_app_ver";
const POLL_INTERVAL = 5 * 60 * 1000; // check every 5 minutes

export function useAppVersion() {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  async function check() {
    try {
      // cache:"no-store" + timestamp param ensures we always get the latest file
      const res = await fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" });
      if (!res.ok) return;
      const { v } = await res.json();
      const current = String(v);
      const stored  = localStorage.getItem(STORAGE_KEY);

      if (!stored) {
        // First visit — store version silently, no banner
        localStorage.setItem(STORAGE_KEY, current);
      } else if (stored !== current) {
        // Version changed since last visit — show banner
        setUpdateAvailable(true);
      }
    } catch {
      // Network error — fail silently, don't annoy user
    }
  }

  function reload() {
    // Persist new version before reloading so banner doesn't reappear
    fetch(`/version.json?_=${Date.now()}`, { cache: "no-store" })
      .then(r => r.json())
      .then(({ v }) => localStorage.setItem(STORAGE_KEY, String(v)))
      .catch(() => {})
      .finally(() => window.location.reload());
  }

  useEffect(() => {
    check();

    // Poll while app is open
    const timer = setInterval(check, POLL_INTERVAL);

    // Also check immediately when user switches back to the tab / reopens PWA
    function onVisibilityChange() {
      if (!document.hidden) check();
    }
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(timer);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { updateAvailable, reload };
}
